var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventEmitter } from "eventemitter3";
import { VERSION_METAPAGE, METAPAGE_KEY_STATE, METAPAGE_KEY_DEFINITION } from "./Constants";
import { JsonRpcMethodsFromParent, } from "./v0_4";
import { stringToRgb, log as MetapageToolsLog, merge, pageLoaded, } from "./MetapageTools";
import { MetapageHashParams } from "./Shared";
import { MetapageEvents } from "./v0_4/events";
export class MetapageIFrameRpcClient extends EventEmitter {
    constructor(metapage, url, iframeId, parentId, consoleBackgroundColor, debug = false) {
        super();
        this.inputs = {};
        this.outputs = {};
        this._disposables = [];
        this._rpcListeners = [];
        this._loaded = false;
        this._onLoaded = [];
        this._sendInputsAfterRegistration = false;
        this._plugin = false;
        this._cachedEventInputsUpdate = {
            iframeId: undefined,
            inputs: undefined
        };
        this._cachedEventOutputsUpdate = {
            iframeId: null,
            inputs: null
        };
        if (!url.startsWith("http")) {
            while (url.startsWith("/")) {
                url = url.substr(1);
            }
            url = window.location.protocol + "//" + window.location.hostname + (window.location.port && window.location.port != ""
                ? ":" + window.location.port
                : "") + "/" + url;
        }
        this.url = url;
        this._metapage = metapage;
        var urlBlob = new URL(this.url);
        if (debug) {
            urlBlob.searchParams.set(MetapageHashParams.mp_debug, "true");
        }
        this.url = urlBlob.href;
        this.id = iframeId;
        this._debug = debug;
        this._parentId = parentId;
        this._color = stringToRgb(this.id);
        this._consoleBackgroundColor = consoleBackgroundColor;
        this._iframe = document.createElement("iframe");
        this._iframe.name = this.id;
        const selfThis = this;
        this.iframe = new Promise((resolve) => {
            pageLoaded().then(() => __awaiter(this, void 0, void 0, function* () {
                if (selfThis._iframe) {
                    const metaframeDef = yield selfThis.getDefinition();
                    if (!selfThis._iframe) {
                        return;
                    }
                    if (metaframeDef === null || metaframeDef === void 0 ? void 0 : metaframeDef.allow) {
                        selfThis._iframe.allow = metaframeDef.allow;
                    }
                    selfThis._iframe.src = this.url;
                    resolve(selfThis._iframe);
                }
            }));
        });
        this.ack = this.ack.bind(this);
        this.dispose = this.dispose.bind(this);
        this.getDefinition = this.getDefinition.bind(this);
        this.getDefinitionUrl = this.getDefinitionUrl.bind(this);
        this.setPlugin = this.setPlugin.bind(this);
        this.hasPermissionsDefinition = this.hasPermissionsDefinition.bind(this);
        this.hasPermissionsState = this.hasPermissionsState.bind(this);
        this.log = this.log.bind(this);
        this.logInternal = this.logInternal.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onInputs = this.onInputs.bind(this);
        this.onOutput = this.onOutput.bind(this);
        this.onOutputs = this.onOutputs.bind(this);
        this.register = this.register.bind(this);
        this.registered = this.registered.bind(this);
        this.sendInputs = this.sendInputs.bind(this);
        this.sendOrBufferPostMessage = this.sendOrBufferPostMessage.bind(this);
        this.sendRpc = this.sendRpc.bind(this);
        this.sendRpcInternal = this.sendRpcInternal.bind(this);
        this.setInput = this.setInput.bind(this);
        this.setInputs = this.setInputs.bind(this);
        this.setMetapage = this.setMetapage.bind(this);
        this.setOutput = this.setOutput.bind(this);
        this.setOutputs = this.setOutputs.bind(this);
        this.setPlugin = this.setPlugin.bind(this);
        this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this);
        this.isDisposed = this.isDisposed.bind(this);
    }
    addListenerReturnDisposer(event, listener) {
        super.addListener(event, listener);
        const disposer = () => {
            super.removeListener(event, listener);
        };
        return disposer;
    }
    setPlugin() {
        if (this._loaded) {
            throw "Cannot setPlugin after MetapageIFrameRpcClient already loaded";
        }
        this._plugin = true;
        return this;
    }
    setMetapage(metapage) {
        this._metapage = metapage;
        return this;
    }
    hasPermissionsState() {
        return (this._definition !== undefined && this._definition.inputs !== undefined && this._definition.inputs[METAPAGE_KEY_STATE] !== undefined);
    }
    hasPermissionsDefinition() {
        return (this._definition !== undefined && this._definition.inputs !== undefined && this._definition.inputs[METAPAGE_KEY_DEFINITION] !== undefined);
    }
    getDefinitionUrl() {
        var url = new URL(this.url);
        url.pathname = url.pathname + (url.pathname.endsWith("/")
            ? "metaframe.json"
            : "/metaframe.json");
        return url.href;
    }
    getDefinition() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._definition) {
                return this._definition;
            }
            var url = this.getDefinitionUrl();
            try {
                const response = yield window.fetch(url);
                if (response.ok) {
                    const metaframeDef = yield response.json();
                    this._definition = metaframeDef;
                    return this._definition;
                }
                else {
                    this.emit(MetapageEvents.Error, `Failed to fetch: ${url}\nStatus: ${response.status}\nStatus text: ${response.statusText}`);
                }
            }
            catch (err) {
                this.emit(MetapageEvents.Error, `Failed to fetch: ${url}\nError: ${err}`);
            }
        });
    }
    setInput(name, inputBlob) {
        console.assert(!!name);
        var inputs = {};
        inputs[name] = inputBlob;
        this.setInputs(inputs);
    }
    setInputs(maybeNewInputs) {
        this.log({ m: 'MetapageIFrameRpcClient', inputs: maybeNewInputs });
        if (!merge(this.inputs, maybeNewInputs)) {
            return this;
        }
        if (!this._loaded) {
            this._sendInputsAfterRegistration = true;
        }
        if (this._iframe.parentNode && this._loaded) {
            this.sendInputs(maybeNewInputs);
        }
        this.emit(MetapageEvents.Inputs, this.inputs);
        if (this._metapage.listenerCount(MetapageEvents.Inputs) > 0) {
            var inputUpdate = {};
            inputUpdate[this.id] = maybeNewInputs;
            this._metapage.emit(MetapageEvents.Inputs, inputUpdate);
        }
        return this;
    }
    setOutput(pipeId, updateBlob) {
        console.assert(!!pipeId);
        var outputs = {};
        outputs[pipeId] = updateBlob;
        this.setOutputs(outputs);
    }
    setOutputs(maybeNewOutputs) {
        if (!merge(this.outputs, maybeNewOutputs)) {
            return;
        }
        this.emit(MetapageEvents.Outputs, maybeNewOutputs);
        if (this._metapage.listenerCount(MetapageEvents.Outputs) > 0) {
            var outputsUpdate = {};
            outputsUpdate[this.id] = this.outputs;
            this._metapage.emit(MetapageEvents.Outputs, outputsUpdate);
        }
    }
    onInputs(f) {
        return this.addListenerReturnDisposer(MetapageEvents.Inputs, f);
    }
    onInput(pipeName, f) {
        var fWrap = function (inputs) {
            if (inputs.hasOwnProperty(pipeName)) {
                f(inputs[pipeName]);
            }
        };
        return this.addListenerReturnDisposer(MetapageEvents.Inputs, fWrap);
    }
    onOutputs(f) {
        return this.addListenerReturnDisposer(MetapageEvents.Outputs, f);
    }
    onOutput(pipeName, f) {
        var fWrap = function (outputs) {
            if (outputs.hasOwnProperty(pipeName)) {
                f(outputs[pipeName]);
            }
        };
        return this.addListenerReturnDisposer(MetapageEvents.Outputs, fWrap);
    }
    isDisposed() {
        return this.inputs === undefined;
    }
    dispose() {
        super.removeAllListeners();
        while (this._disposables && this._disposables.length > 0) {
            const val = this._disposables.pop();
            if (val) {
                val();
            }
        }
        this._rpcListeners = undefined;
        this.inputs = undefined;
        this.outputs = undefined;
        if (this._iframe && this._iframe.parentNode) {
            this._iframe.parentNode.removeChild(this._iframe);
        }
        this._iframe = undefined;
        this._bufferMessages = undefined;
        if (this._bufferTimeout) {
            window.clearInterval(this._bufferTimeout);
            this._bufferTimeout = undefined;
        }
        this._metapage = undefined;
    }
    register() {
        var response = {
            iframeId: this.id,
            parentId: this._parentId,
            plugin: this._plugin,
            state: {
                inputs: this.inputs
            },
            version: VERSION_METAPAGE
        };
        this.sendRpcInternal(JsonRpcMethodsFromParent.SetupIframeServerResponse, response);
    }
    registered(version) {
        this.log({ m: 'MetapageIFrameRpcClient.registered', inputs: this.inputs });
        if (this._loaded) {
            return;
        }
        if (!version) {
            throw 'Cannot register without a version';
        }
        this.version = version;
        this._loaded = true;
        while (this._onLoaded && this._onLoaded.length > 0) {
            this._onLoaded.pop()();
        }
        if (this._sendInputsAfterRegistration) {
            this.sendInputs(this.inputs);
        }
    }
    sendInputs(inputs) {
        this.sendRpc(JsonRpcMethodsFromParent.InputsUpdate, {
            inputs: inputs,
            parentId: this._parentId
        });
    }
    sendRpc(method, params) {
        if (this._iframe.parentNode && this._loaded) {
            this.sendRpcInternal(method, params);
        }
        else {
            this._metapage.error("sending rpc later");
            const thing = this;
            this._onLoaded.push(() => {
                thing.sendRpcInternal(method, params);
            });
        }
    }
    ack(message) {
        this.log("⚒ ⚒ ⚒ calling ack");
        if (this._debug) {
            this.log("⚒ ⚒ ⚒ sending ack from client to frame");
            var payload = {
                message: message
            };
            this.sendRpc(JsonRpcMethodsFromParent.MessageAck, payload);
        }
        else {
            this.log("⚒ ⚒ ⚒ NOT sending ack from client to frame since not debug mode");
        }
    }
    log(o) {
        if (!this._debug) {
            return;
        }
        this.logInternal(o);
    }
    logInternal(o) {
        let s;
        if (typeof o === "string") {
            s = o;
        }
        else if (typeof o === "string") {
            s = o + "";
        }
        else {
            s = JSON.stringify(o);
        }
        MetapageToolsLog(`Metapage[${this._parentId}] Metaframe[${this.id}] ${s}`, this._color, this._consoleBackgroundColor);
    }
    sendRpcInternal(method, params) {
        const messageJSON = {
            id: "_",
            iframeId: this.id,
            jsonrpc: "2.0",
            method: method,
            params: params,
            parentId: this._parentId
        };
        if (this._iframe) {
            this.sendOrBufferPostMessage(messageJSON);
        }
        else {
            this._metapage.error(`Cannot send to child iframe messageJSON=${JSON.stringify(messageJSON).substr(0, 200)}`);
        }
    }
    sendOrBufferPostMessage(message) {
        if (this._iframe && this._iframe.contentWindow) {
            this._iframe.contentWindow.postMessage(message, this.url);
        }
        else {
            if (!this._bufferMessages) {
                this._bufferMessages = [message];
                const thing = this;
                this._bufferTimeout = window.setInterval(function () {
                    if (thing._iframe && thing._iframe.contentWindow) {
                        thing._bufferMessages.forEach(m => thing._iframe.contentWindow.postMessage(m, thing.url));
                        window.clearInterval(thing._bufferTimeout);
                        thing._bufferTimeout = undefined;
                        thing._bufferMessages = undefined;
                    }
                }, 0);
            }
            else {
                this._bufferMessages.push(message);
            }
        }
    }
}
//# sourceMappingURL=MetapageIFrameRpcClient.js.map